// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reservation-category {
  background-color: var(--reservation-bg);
  color: var(--reservation-text);
  border-left-color: var(--reservation-accent);
}

.theme-dark .reservation-category {
  background-color: var(--reservation-dark-bg);
  color: var(--reservation-dark-text);
  border-left-color: var(--reservation-dark-accent);
}

.reservation-event:hover {
  box-shadow: inset 0 0 0 1px var(--reservation-accent);
}

.reservation-event:focus-visible {
  outline: 2px solid var(--reservation-accent);
  outline-offset: 2px;
}

.theme-dark .reservation-event:hover,
.theme-dark .reservation-event:focus-visible {
  outline-color: var(--reservation-dark-accent);
  box-shadow: inset 0 0 0 1px var(--reservation-dark-accent);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Agenda/ReservasCalendario.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;;EAEE,6CAA6C;EAC7C,0DAA0D;AAC5D","sourcesContent":[".reservation-category {\n  background-color: var(--reservation-bg);\n  color: var(--reservation-text);\n  border-left-color: var(--reservation-accent);\n}\n\n.theme-dark .reservation-category {\n  background-color: var(--reservation-dark-bg);\n  color: var(--reservation-dark-text);\n  border-left-color: var(--reservation-dark-accent);\n}\n\n.reservation-event:hover {\n  box-shadow: inset 0 0 0 1px var(--reservation-accent);\n}\n\n.reservation-event:focus-visible {\n  outline: 2px solid var(--reservation-accent);\n  outline-offset: 2px;\n}\n\n.theme-dark .reservation-event:hover,\n.theme-dark .reservation-event:focus-visible {\n  outline-color: var(--reservation-dark-accent);\n  box-shadow: inset 0 0 0 1px var(--reservation-dark-accent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
